import { Yield } from '../../abacus/interfaces/yield.interface'

export const aiTagYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  }
]
